export const getInstanceName = (id: string) => {
  const instanceId = id.split('.')[0]
  return instanceId
}
